export const checkIfKeyExist = (objectName: Record<string, unknown>, keyName: string): boolean => {
    const keyExist = Object.keys(objectName).some(key => key === keyName)
    return keyExist
}
